import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface IProductViewCareInformationModalDataContent extends Catalog.IBlockData<IProductViewCareInformationModalDataContent> {
    copy: string;
}

export const CARE_INFORMATION_MODAL_ID = 'careInformationModal';

@ICmsComponent<ProductViewCareInformationModalComponent>({
    id: 'product-view-care-information',
    block: {
        url: 'product-view-care-information',
        autoload: 'prerender'
    },
    onDemandOnly: true,
    name: 'Product Care Information Block',
    description: 'Product Care Information Block',
    fields: [
        <NICmsContentField.IField>{
            key: 'copy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            required: true
        }
    ]
})
@Component({
    selector: 'product-view-care-information-modal',
    templateUrl: './product-view-care-information-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule]
})
export class ProductViewCareInformationModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IProductViewCareInformationModalDataContent;

    @Input()
    variant?: string;
}
